import { useParams, Link } from 'react-router-dom';
import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ComicCard from '@/components/base/ComicCard';
import Breadcrumb from '@/components/base/Breadcrumb';
import ScrollToTop from '@/components/base/ScrollToTop';
import SeoHead from '@/components/base/SeoHead';
import JsonLd from '@/components/base/JsonLd';
import { getComicById, getPopularComics } from '@/mocks/comics';
import { categories } from '@/mocks/categories';

const READING_IMAGES: string[] = [
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comic%20page%20art%2C%20vertical%20scroll%20webtoon%20style%2C%20detailed%20characters%20and%20background%2C%20dramatic%20storytelling%2C%20clean%20line%20art%20with%20soft%20colors%2C%20manga%20panel%20layout%2C%20professional%20comic%20illustration&width=800&height=1100&seq=reading-p01&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comic%20page%20art%2C%20vertical%20scroll%20webtoon%20style%2C%20dynamic%20action%20scene%2C%20dramatic%20expressions%2C%20clean%20line%20art%20with%20vibrant%20colors%2C%20manga%20panel%20layout%2C%20professional%20comic%20illustration&width=800&height=1000&seq=reading-p02&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comic%20page%20art%2C%20vertical%20scroll%20webtoon%20style%2C%20emotional%20dialogue%20scene%2C%20close%20up%20characters%2C%20soft%20warm%20colors%2C%20manga%20panel%20layout%2C%20professional%20comic%20illustration&width=800&height=1200&seq=reading-p03&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comic%20page%20art%2C%20vertical%20scroll%20webtoon%20style%2C%20cityscape%20background%20scene%2C%20detailed%20environment%2C%20atmospheric%20lighting%2C%20manga%20panel%20layout%2C%20professional%20comic%20illustration&width=800&height=1100&seq=reading-p04&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comic%20page%20art%2C%20vertical%20scroll%20webtoon%20style%2C%20dramatic%20confrontation%20scene%2C%20intense%20expressions%2C%20bold%20colors%2C%20manga%20panel%20layout%2C%20professional%20comic%20illustration&width=800&height=1000&seq=reading-p05&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comic%20page%20art%2C%20vertical%20scroll%20webtoon%20style%2C%20romantic%20scene%20with%20soft%20lighting%2C%20beautiful%20characters%2C%20pastel%20colors%2C%20manga%20panel%20layout%2C%20professional%20comic%20illustration&width=800&height=1200&seq=reading-p06&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comic%20page%20art%2C%20vertical%20scroll%20webtoon%20style%2C%20mysterious%20atmosphere%2C%20dark%20shadows%2C%20suspenseful%20composition%2C%20manga%20panel%20layout%2C%20professional%20comic%20illustration&width=800&height=1100&seq=reading-p07&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comic%20page%20art%2C%20vertical%20scroll%20webtoon%20style%2C%20comedic%20scene%2C%20exaggerated%20expressions%2C%20bright%20playful%20colors%2C%20manga%20panel%20layout%2C%20professional%20comic%20illustration&width=800&height=1000&seq=reading-p08&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comic%20page%20art%2C%20vertical%20scroll%20webtoon%20style%2C%20epic%20battle%20scene%2C%20dynamic%20special%20effects%2C%20dramatic%20lighting%2C%20manga%20panel%20layout%2C%20professional%20comic%20illustration&width=800&height=1200&seq=reading-p09&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comic%20page%20art%2C%20vertical%20scroll%20webtoon%20style%2C%20peaceful%20ending%20scene%2C%20soft%20sunset%20colors%2C%20warm%20atmosphere%2C%20manga%20panel%20layout%2C%20professional%20comic%20illustration&width=800&height=1100&seq=reading-p10&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comic%20page%20art%2C%20vertical%20scroll%20webtoon%20style%2C%20magical%20transformation%20scene%2C%20glowing%20effects%2C%20fantasy%20elements%2C%20manga%20panel%20layout%2C%20professional%20comic%20illustration&width=800&height=1000&seq=reading-p11&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comic%20page%20art%2C%20vertical%20scroll%20webtoon%20style%2C%20emotional%20reunion%20scene%2C%20tearful%20expressions%2C%20warm%20lighting%2C%20manga%20panel%20layout%2C%20professional%20comic%20illustration&width=800&height=1200&seq=reading-p12&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comic%20page%20art%2C%20vertical%20scroll%20webtoon%20style%2C%20school%20life%20scene%2C%20classroom%20setting%2C%20youthful%20energy%2C%20manga%20panel%20layout%2C%20professional%20comic%20illustration&width=800&height=1100&seq=reading-p13&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comic%20page%20art%2C%20vertical%20scroll%20webtoon%20style%2C%20night%20scene%20with%20stars%2C%20reflective%20mood%2C%20cool%20blue%20tones%2C%20manga%20panel%20layout%2C%20professional%20comic%20illustration&width=800&height=1000&seq=reading-p14&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comic%20page%20art%2C%20vertical%20scroll%20webtoon%20style%2C%20climactic%20showdown%2C%20powerful%20energy%20effects%2C%20dramatic%20composition%2C%20manga%20panel%20layout%2C%20professional%20comic%20illustration&width=800&height=1200&seq=reading-p15&orientation=portrait',
];

function formatViews(views: number): string {
  if (views >= 10000) return (views / 10000).toFixed(1) + '万';
  return views.toString();
}

export default function ComicDetail() {
  const { id } = useParams<{ id: string }>();
  const comic = id ? getComicById(id) : undefined;
  const [selectedChapter, setSelectedChapter] = useState<number | null>(null);
  const popularComics = getPopularComics(4);

  if (!comic) {
    return (
      <>
        <SeoHead title="漫画未找到 - 韩漫网" description="未找到该漫画，请浏览其他精彩韩漫。" keywords="韩漫,漫画" canonicalUrl="https://www.hanmanwang.com/comic/not-found" />
        <ScrollToTop />
        <div className="min-h-screen bg-background-50">
          <Navbar />
          <main className="pt-24 pb-16 px-4 md:px-6 max-w-7xl mx-auto text-center">
            <h1 className="text-2xl font-bold text-foreground-950 mb-4">漫画未找到</h1>
            <Link to="/" className="text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap">返回首页</Link>
          </main>
          <Footer />
        </div>
      </>
    );
  }

  const category = categories.find((c) => c.slug === comic.category);
  const pageCount = selectedChapter
    ? (comic.chapters.find((ch) => ch.number === selectedChapter)?.pageCount || 10)
    : 0;
  const displayImages = READING_IMAGES.slice(0, Math.min(pageCount, READING_IMAGES.length));

  const pageTitle = `${comic.title}_${comic.title}韩漫免费在线阅读_韩漫网`;
  const pageDesc = `${comic.title}韩漫免费在线观看——${comic.description.substring(0, 100)}。韩漫网提供${comic.title}下拉式免费阅读体验，无需下载即可畅读全部章节。`;
  const pageKeywords = `${comic.title},${comic.title}韩漫,韩漫网,免费韩漫,${category?.name || ''}漫画`;

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.hanmanwang.com' },
      { '@type': 'ListItem', position: 2, name: `${category?.name || ''}韩漫`, item: `https://www.hanmanwang.com/category/${comic.category}` },
      { '@type': 'ListItem', position: 3, name: comic.title, item: `https://www.hanmanwang.com/comic/${comic.id}` },
    ],
  };

  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: `${comic.title} - 韩漫免费在线阅读`,
    description: comic.description,
    author: { '@type': 'Person', name: comic.author },
    datePublished: comic.createdAt,
    dateModified: comic.updatedAt,
    mainEntityOfPage: { '@type': 'WebPage', '@id': `https://www.hanmanwang.com/comic/${comic.id}` },
  };

  if (selectedChapter) {
    return (
      <>
        <SeoHead
          title={`${comic.title} 第${selectedChapter}话 - 韩漫网`}
          description={`${comic.title}第${selectedChapter}话免费在线观看——下拉式韩漫阅读，无需下载，流畅体验。`}
          keywords={pageKeywords}
          canonicalUrl={`https://www.hanmanwang.com/comic/${comic.id}`}
          ogType="article"
        />
        <ScrollToTop />
        <div className="min-h-screen bg-background-950">
          <div className="bg-background-950 text-background-50 sticky top-0 z-40">
            <div className="max-w-2xl mx-auto px-4 py-3 flex items-center justify-between">
              <button
                onClick={() => setSelectedChapter(null)}
                className="flex items-center gap-1 text-sm text-background-50/80 hover:text-background-50 transition-colors whitespace-nowrap"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-arrow-left-line"></i>
                </div>
                返回详情
              </button>
              <span className="text-sm font-medium">{comic.title} - 第{selectedChapter}话</span>
              <div className="flex items-center gap-3">
                {selectedChapter > 1 && (
                  <button
                    onClick={() => setSelectedChapter(selectedChapter - 1)}
                    className="text-sm text-background-50/80 hover:text-background-50 transition-colors whitespace-nowrap"
                  >
                    上一话
                  </button>
                )}
                {selectedChapter < comic.chapters.length && (
                  <button
                    onClick={() => setSelectedChapter(selectedChapter + 1)}
                    className="text-sm text-primary-400 hover:text-primary-300 transition-colors whitespace-nowrap"
                  >
                    下一话
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className="max-w-2xl mx-auto">
            {displayImages.map((img, i) => (
              <img
                key={i}
                src={img}
                alt={`${comic.title} 第${selectedChapter}话 - 第${i + 1}页`}
                className="w-full block"
              />
            ))}
          </div>
          <div className="bg-background-950 text-background-50">
            <div className="max-w-2xl mx-auto px-4 py-4 flex items-center justify-between">
              <button
                onClick={() => setSelectedChapter(null)}
                className="flex items-center gap-1 text-sm text-background-50/80 hover:text-background-50 transition-colors whitespace-nowrap"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-arrow-left-line"></i>
                </div>
                返回详情
              </button>
              <div className="flex items-center gap-3">
                {selectedChapter > 1 && (
                  <button
                    onClick={() => setSelectedChapter(selectedChapter - 1)}
                    className="px-4 py-2 rounded-full bg-background-50/10 text-sm text-background-50/80 hover:text-background-50 hover:bg-background-50/20 transition-colors whitespace-nowrap"
                  >
                    上一话
                  </button>
                )}
                {selectedChapter < comic.chapters.length && (
                  <button
                    onClick={() => setSelectedChapter(selectedChapter + 1)}
                    className="px-4 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
                  >
                    下一话
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <SeoHead
        title={pageTitle}
        description={pageDesc}
        keywords={pageKeywords}
        canonicalUrl={`https://www.hanmanwang.com/comic/${comic.id}`}
        ogType="article"
      />
      <JsonLd data={breadcrumbSchema} />
      <JsonLd data={articleSchema} />

      <ScrollToTop />
      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-24 pb-16 px-4 md:px-6 max-w-7xl mx-auto">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: `${category?.name || ''}韩漫`, href: `/category/${comic.category}` },
              { label: comic.title },
            ]}
          />

          <div className="mt-6 flex flex-col md:flex-row gap-8">
            <div className="flex-shrink-0 w-48 md:w-56 mx-auto md:mx-0">
              <div className="rounded-xl overflow-hidden border border-background-200" style={{ aspectRatio: '3/4' }}>
                <img src={comic.cover} alt={comic.title} className="w-full h-full object-cover object-top" />
              </div>
            </div>
            <div className="flex-1">
              <h1 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
                {comic.title}
              </h1>
              <div className="flex flex-wrap items-center gap-3 mt-3">
                <span className={`text-xs px-2.5 py-1 rounded-full font-medium whitespace-nowrap ${comic.status === 'ongoing' ? 'bg-accent-500 text-background-50' : 'bg-foreground-600 text-background-50'}`}>
                  {comic.status === 'ongoing' ? '连载中' : '已完结'}
                </span>
                <span className="text-sm text-foreground-500">作者：{comic.author}</span>
                <span className="text-sm text-foreground-500">
                  <span className="inline-flex items-center gap-0.5">
                    <i className="ri-eye-line text-xs"></i>
                    {formatViews(comic.views)}
                  </span>
                </span>
                <span className="text-sm text-foreground-500">
                  <span className="inline-flex items-center gap-0.5">
                    <i className="ri-star-fill text-yellow-400 text-xs"></i>
                    {comic.rating}
                  </span>
                </span>
              </div>

              <div className="flex flex-wrap gap-2 mt-4">
                {comic.tags.map((tag) => (
                  <span key={tag} className="px-3 py-1 rounded-full bg-background-100 text-xs text-foreground-600 whitespace-nowrap">
                    {tag}
                  </span>
                ))}
              </div>

              <p className="mt-5 text-sm text-foreground-600 leading-relaxed">{comic.description}</p>

              <div className="mt-6 flex flex-col sm:flex-row gap-3">
                <button
                  onClick={() => setSelectedChapter(1)}
                  className="px-8 py-3 bg-primary-500 text-background-50 rounded-full font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
                >
                  从第一话开始阅读
                </button>
                <button
                  onClick={() => setSelectedChapter(comic.chapters.length)}
                  className="px-8 py-3 bg-background-100 text-foreground-700 rounded-full font-medium hover:bg-background-200 transition-colors whitespace-nowrap"
                >
                  阅读最新章节
                </button>
              </div>
            </div>
          </div>

          <section className="mt-12">
            <h2 className="text-xl font-bold text-foreground-950 mb-5" style={{ fontFamily: 'var(--font-heading)' }}>
              章节目录
              <span className="text-sm text-foreground-500 font-normal ml-2">共{comic.chapters.length}话</span>
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2">
              {[...comic.chapters].reverse().map((chapter) => (
                <button
                  key={chapter.id}
                  onClick={() => setSelectedChapter(chapter.number)}
                  className="flex items-center justify-between p-3 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 hover:bg-primary-50/30 transition-all duration-200 text-left group"
                >
                  <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                    第{chapter.number}话 {chapter.title}
                  </span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap ml-2">{chapter.createdAt}</span>
                </button>
              ))}
            </div>
          </section>

          <section className="mt-16">
            <h2 className="text-xl font-bold text-foreground-950 mb-5" style={{ fontFamily: 'var(--font-heading)' }}>
              猜你喜欢
            </h2>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-4">
              {popularComics.filter((c) => c.id !== comic.id).slice(0, 4).map((c) => (
                <ComicCard key={c.id} comic={c} />
              ))}
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}